import { defineComponent as _defineComponent } from 'vue'
import ReportVulnerabilityListItemSkeleton from '@/_core/entities/report/ui/ReportVulnerabilityListItem/ReportVulnerabilityListItemSkeleton.vue';
import { REPORT_PAGE_LIMIT } from '@/_core/entities/report/models/consts';

export default /*#__PURE__*/_defineComponent({
  __name: 'ReportPageContentSkeleton',
  setup(__props) {


return { __sfc: true,ReportVulnerabilityListItemSkeleton, REPORT_PAGE_LIMIT }
}

})